import { TableColumn } from "features/common/components/Table/Table.types";
import { convertToLocaleTime } from "features/common/lib/date";

export const columns: TableColumn[] = [
  {
    id: "fileType",
    label: "File type",
    disableSort: true,
  },
  {
    id: "user",
    label: "User",
    disableSort: true,
  },
  {
    id: "lastImport",
    label: "Last import",
    disableSort: true,
    Cell: (row) => row.lastImport && convertToLocaleTime(row.lastImport),
  },
];
